var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.505 20.25C6.376 20.25 6.246 20.217 6.13 20.149C5.898 20.015 5.755 19.767 5.755 19.5V4.49999C5.755 4.23199 5.898 3.98399 6.13 3.85099C6.362 3.71699 6.648 3.71699 6.88 3.85099L19.87 11.351C20.102 11.485 20.245 11.732 20.245 12C20.245 12.268 20.102 12.516 19.87 12.649L6.88 20.149C6.764 20.217 6.634 20.25 6.505 20.25ZM7.255 5.79899V18.201L17.995 12L7.255 5.79899Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStroke);
export default __webpack_public_path__ + "static/media/play-stroke.e91700a7e0a7a88cf9cd24e9d4aff43f.svg";
export { ForwardRef as ReactComponent };